import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import { spacesClient } from '#pplx_generated/typespec/rest/spaces/client.js';
export const listSpacePinnedThreads = async ({ spaceUuid, threadType, searchTerm, limit, filterByUser, reason, throwOnError = false, }) => {
    try {
        const { data, error, response } = await spacesClient.GET('/rest/spaces/{space_uuid}/pins/threads', reason, {
            params: {
                path: { space_uuid: spaceUuid },
                query: {
                    include_assets: true,
                    limit,
                    filter_by_user: filterByUser,
                    ...(threadType ? { thread_type: threadType } : {}),
                    ...(searchTerm ? { search_term: searchTerm } : {}),
                },
            },
            timeoutMs: getQueryTimeoutMs(),
        });
        if (error || !data || !Array.isArray(data)) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: 'Failed to list space pinned threads',
                cause: error,
                status: response.status ?? 0,
            });
        }
        return data;
    }
    catch (err) {
        logger.error(err);
        if (throwOnError) {
            throw err;
        }
        return [];
    }
};
//# sourceMappingURL=listSpacePinnedThreads.js.map